import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";
import { MstSyouninGroup, MstSyouninGroupUser } from "@/types/SyouninGroup";

export class MstSyouninGroupUsersApi extends BaseApi {
  /**
   * 承認グループに所属可能なユーザー一覧を返却します
   * 同種のグループに所属している場合は結果から除外されます
   * @param syouninType 所属させたい承認グループの承認種別
   * @returns 
   */
  public async getSelectableSyouninGroupUserList(syouninType?: number): Promise<MstSyouninGroupUser[]> {
    try {
      const res =  await this.post<MstSyouninGroupUser[]>(Config.API_URL + `/master/syounin_group_users/get_selectable_syounin_group_user_list`, { 'syouninType': syouninType });
      return res.data
    } catch (e: any) {
      throw e;
    }
  }

  /**
  * 承認グループを検索します
  * @returns
  */
  public async searchSyouninGroup(): Promise<any> {
    try {
      return await this.get(Config.API_URL + `/master/syounin_groups/search_groups`, {});
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 承認グループに所属するユーザーを新規登録します
   * @param params
   * @returns
   */
  public async createSyouninGroupUsers(params: MstSyouninGroup): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/master/syounin_group_users/create`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /**
 * 承認グループに所属するユーザーを追加します
 * @param params
 * @returns
 */
  public async addSyouninGroupUsers(params: MstSyouninGroup): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/master/syounin_group_users/add`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループに所属するユーザーを削除します */
  public async deleteSyouninGroupUser(mstSyouninGroupUserId: number, mstSyouninGroupId: number): Promise<any> {
    try {
      return await this.delete(Config.API_URL + `/master/syounin_group_users/remove_groupuser`,
        {
          'mstSyouninGroupUserId': mstSyouninGroupUserId,
          'mstSyouninGroupId': mstSyouninGroupId
        }
      );
    } catch (e: any) {
      throw e;
    }
  }
}
